import clsx from 'clsx'
import { IconButton, useTheme } from '@mui/material'
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react'

import useStyles from './styles'

interface NavigatorProps {
  files: Media[]
  navigate: (index: number) => void
  selectedFileIndex: number
}
const Navigator: React.FC<NavigatorProps> = ({
  files,
  navigate,
  selectedFileIndex
}) => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <>
      <IconButton
        className={clsx(classes.arrow, classes.leftArrow)}
        disabled={selectedFileIndex === 0}
        onClick={() => {
          navigate(selectedFileIndex - 1)
        }}
      >
        <ArrowLeft2 size={theme.size.base} />
      </IconButton>
      <IconButton
        className={clsx(classes.arrow, classes.rightArrow)}
        disabled={selectedFileIndex === files.length - 1}
        onClick={() => {
          navigate(selectedFileIndex + 1)
        }}
      >
        <ArrowRight2 size={theme.size.base} />
      </IconButton>
    </>
  )
}
export default Navigator
